import { render } from "./HeadingIcon.vue?vue&type=template&id=3ec9eaf9&scoped=true"
import script from "./HeadingIcon.vue?vue&type=script&lang=js"
export * from "./HeadingIcon.vue?vue&type=script&lang=js"

import "./HeadingIcon.vue?vue&type=style&index=0&id=3ec9eaf9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec9eaf9"]])

export default __exports__